const WidgetMessages: { [key: string]: string } = {
  DISMISS: "dest1PhoenixHideIframe"
};

export default WidgetMessages;
